import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProgressSpinnerService {
  public spinner$ = new BehaviorSubject<boolean>(false);
  private debounce = 10;

  constructor() {
    // this.spinner$ = new Subject<boolean>();
  }

  showSpinner() {
    setTimeout(() => {
      this.spinner$.next(true);
    }, this.debounce);
  }

  hideSpinner() {
    setTimeout(() => {
      this.spinner$.next(false);
    }, this.debounce);
  }
}
